import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './initialState'

const commissionsByProductTypeSlice = createSlice({
  name: 'commissionsByProductType',
  initialState,
  reducers: {
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setIsEditModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEditModalOpen = action.payload
    },
    setSelectedId: (state, action: PayloadAction<string | null>) => {
      state.selectedId = action.payload
    },
    reset: () => initialState
  }
})

export const commissionsByProductTypeActions =
  commissionsByProductTypeSlice.actions
export const { reducer: commissionsByProductTypeReducer } =
  commissionsByProductTypeSlice
